<template>
  <div class="home">
    <h1>D'Institute Signature Pad</h1>
    <div class="actions">
      <button @click="reloadPage()">
        <svg width="18px" height="21px" viewBox="0 0 18 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M17.6328125,10.34375 C17.7109379,10.7994814 17.75,11.2682268 17.75,11.75 C17.75,12.9479227 17.5221377,14.0872342 17.0664062,15.1679688 C16.6236957,16.2096406 15.998702,17.1341105 15.1914062,17.9414062 C14.3841105,18.748702 13.4531303,19.3736957 12.3984375,19.8164062 C11.3177029,20.2721377 10.1849018,20.5 9,20.5 C7.81509824,20.5 6.68229707,20.2721377 5.6015625,19.8164062 C4.54686973,19.3736957 3.61588945,18.748702 2.80859375,17.9414062 C2.00129805,17.1341105 1.3763043,16.2031303 0.93359375,15.1484375 C0.477862305,14.0677029 0.25,12.9349018 0.25,11.75 C0.25,10.5650982 0.477862305,9.43229707 0.93359375,8.3515625 C1.3763043,7.29686973 2.00129805,6.36588945 2.80859375,5.55859375 C3.61588945,4.75129805 4.54686973,4.1263043 5.6015625,3.68359375 C6.66927617,3.2408832 7.78254629,3.0130209 8.94140625,3 L7.65234375,1.69140625 C7.50911387,1.56119727 7.4375,1.39843848 7.4375,1.203125 C7.4375,1.00781152 7.50585869,0.841797559 7.64257812,0.705078125 C7.77929756,0.568358691 7.94531152,0.5 8.140625,0.5 C8.33593848,0.5 8.50520762,0.571613867 8.6484375,0.71484375 L11.2851562,3.3515625 C11.4283861,3.49479238 11.5,3.66406152 11.5,3.859375 C11.5,4.05468848 11.4283861,4.21744727 11.2851562,4.34765625 L8.6484375,7.00390625 C8.50520762,7.14713613 8.33593848,7.21875 8.140625,7.21875 C7.94531152,7.21875 7.77929756,7.14713613 7.64257812,7.00390625 C7.50585869,6.86067637 7.4375,6.6946624 7.4375,6.50585938 C7.4375,6.31705635 7.50911387,6.15104238 7.65234375,6.0078125 L9.25390625,4.40625 L9,4.40625 L9,4.40625 C8.02343262,4.40625 7.08594199,4.59179502 6.1875,4.96289062 C5.28905801,5.33398623 4.49479512,5.86457988 3.8046875,6.5546875 C3.11457988,7.24479512 2.58398623,8.03905801 2.21289062,8.9375 C1.84179502,9.83594199 1.65625,10.7734326 1.65625,11.75 C1.65625,12.7265674 1.84179502,13.664058 2.21289062,14.5625 C2.58398623,15.460942 3.11457988,16.2552049 3.8046875,16.9453125 C4.49479512,17.6354201 5.28905801,18.1660138 6.1875,18.5371094 C7.08594199,18.908205 8.02343262,19.09375 9,19.09375 C9.97656738,19.09375 10.914058,18.908205 11.8125,18.5371094 C12.710942,18.1660138 13.5052049,17.6354201 14.1953125,16.9453125 C14.8854201,16.2552049 15.4160138,15.4641972 15.7871094,14.5722656 C16.158205,13.6803341 16.34375,12.7395883 16.34375,11.75 C16.34375,11.3333313 16.3111982,10.9427102 16.2460938,10.578125 C16.220052,10.3828115 16.2623692,10.207032 16.3730469,10.0507812 C16.4837245,9.89453047 16.6334626,9.80013037 16.8222656,9.76757812 C17.0110687,9.73502588 17.1868481,9.77408799 17.3496094,9.88476562 C17.5123706,9.99544326 17.6067707,10.1484365 17.6328125,10.34375 Z" id="" fill="#000000" fill-rule="nonzero"></path>
          </g>
        </svg>
      </button>
      <button v-if="ids.pacientId"
              @click="handleClear">
        <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon id="" fill="#000000" fill-rule="nonzero" points="20.18 2.20749141 12.2074914 10.18 20.18 18.1525086 18.1525086 20.18 10.18 12.2074914 2.20749141 20.18 0.18 18.1525086 8.15250859 10.18 0.18 2.20749141 2.20749141 0.18 10.18 8.15250859 18.1525086 0.18"></polygon>
          </g>
        </svg>
      </button>
      <button v-if="ids.pacientId"
              @click="handleSave">
        <svg width="18px" height="14px" viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M17.6495758,3.17409424 C17.6495758,3.45311243 17.5379685,3.73213062 17.3370754,3.93302371 L7.7388497,13.5312494 C7.53795661,13.7321425 7.25893842,13.8437498 6.97992023,13.8437498 C6.70090204,13.8437498 6.42188385,13.7321425 6.22099075,13.5312494 L0.662948411,7.9732071 C0.462055314,7.772314 0.350448038,7.49329581 0.350448038,7.21427763 C0.350448038,6.93525944 0.462055314,6.65624125 0.662948411,6.45534815 L2.18080736,4.9374892 C2.38170046,4.7365961 2.66071865,4.62498882 2.93973684,4.62498882 C3.21875503,4.62498882 3.49777322,4.7365961 3.69866632,4.9374892 L6.97992023,8.22990384 L14.3013575,0.897305809 C14.5022506,0.696412712 14.7812688,0.584805436 15.060287,0.584805436 C15.3393052,0.584805436 15.6183234,0.696412712 15.8192165,0.897305809 L17.3370754,2.41516476 C17.5379685,2.61605786 17.6495758,2.89507605 17.6495758,3.17409424 Z" id="" fill="#000000" fill-rule="nonzero"></path>
          </g>
        </svg>
      </button>
    </div>
    <div v-show="ids && ids.pacientId">
      <canvas id="canvas"
              width="600"
              height="300" />
    </div>
    <div v-show="!ids.pacientId && !isSaved">
      Nu exista tratament de semnat.
    </div>
    <div v-show="isSaved">
      Semnatura salvata cu succes.
    </div>
  </div>
</template>

<script>
  import SignaturePad from 'signature_pad'
  import { mapState } from 'vuex'

  export default {
    name: 'Home',
    data () {
      return {
        signaturePad: undefined
      }
    },
    computed: {
      ...mapState(['ids', 'isSaved'])
    },
    created () {
      this.$store.dispatch('get_pacient_details')
    },
    mounted () {
      const canvas = document.querySelector("canvas");
      this.signaturePad = new SignaturePad(canvas);
    },
    methods: {
      handleClear () {
        this.signaturePad.clear();
      },
      handleSave () {
        this.$store.dispatch('save_signature', this.signaturePad.toDataURL())
      },
      reloadPage () {
        window.location.reload()
      }
    },
    watch: {
      ids: {
        handler (val) {
          // debugger
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss">
  .home {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    h1 {
      //transform: translateX(-30px);
    }
    > div {
      display: flex;
      align-items: flex-end;
    }
    button {
      width: 100px;
      height: 100px;
      margin: 0 24px 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: lightgray;
      svg {
        transform: scale(2);
      }
    }
    .actions button:last-child {
      background-color: #23b723;
      margin-top: 6px;
      svg path {
        fill: white;
      }
    }
    .actions button:first-child {
      background-color: white;
      svg path {
        fill: black;
      }
    }
    canvas {
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      background-color: white;
    }
  }
</style>
